import { cambodiaDestinationsCardData } from './cambodia/cambodia-destinations-card-map';
import { thailandDestinationsCardData } from './thailand/thailand-destinations-card-map';
import { vietnamDestinationsCardData } from './vietnam/vietnam-destinations-card-map';

export interface DestinationData {
  articleLink?: string;
  title: string;
  description: string;
  relatedArticlesSlugs?: string[];
  imageUrl: string;
  date?: string;
  readTime?: string;
  slug: string;
  klookUrl?: string;
  getYourGuideUrl?: string;
  titleNameOverride?: string;
}

interface DestinationsData {
  [key: string]: DestinationData[];
}

export const destinationCardData: DestinationsData = {
  thailand: thailandDestinationsCardData,
  vietnam: vietnamDestinationsCardData,
  cambodia: cambodiaDestinationsCardData,
};
